/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ scope: NonNullable<unknown> }} Disabled_Websites_Already_Permanently_Disabled_MessageInputs */

const en_disabled_websites_already_permanently_disabled_message = /** @type {(inputs: Disabled_Websites_Already_Permanently_Disabled_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.scope === "domain") return /** @type {LocalizedString} */ (`This domain is already permanently disabled`);
	return /** @type {LocalizedString} */ (`This page is already permanently disabled`)
	
};

const es_disabled_websites_already_permanently_disabled_message = /** @type {(inputs: Disabled_Websites_Already_Permanently_Disabled_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.scope === "domain") return /** @type {LocalizedString} */ (`Este dominio ya está deshabilitado permanentemente`);
	return /** @type {LocalizedString} */ (`Esta página ya está deshabilitada permanentemente`)
	
};

/**
* | scope | output |
* | --- | --- |
* | "domain" | "This domain is already permanently disabled" |
* | * | "This page is already permanently disabled" |
*
* @param {Disabled_Websites_Already_Permanently_Disabled_MessageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_already_permanently_disabled_message = /** @type {((inputs: Disabled_Websites_Already_Permanently_Disabled_MessageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_Already_Permanently_Disabled_MessageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_already_permanently_disabled_message(inputs)
	return en_disabled_websites_already_permanently_disabled_message(inputs)
});